import * as React from 'react';

import type { DescriptionPage_DifficultyLevel as DifficultyLevel } from '__generated__/graphql-types';

import { withMediaMinWidthMobile } from 'bundles/browse/utils';
import DesktopEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/DesktopEntityCard';
import MobileEntityCard from 'bundles/unified-seo-content-common/components/entity-cards/MobileEntityCard';

export type ArticleRichEntityCardProps = {
  ctaHref: string;
  ctaLabel?: string;
  ctaAriaLabel: string;
  imageSrc: string;
  imageAlt: string;
  title: string;
  subtitle?: string;
  cardMetaData: {
    entityType: string;
    level: DifficultyLevel | null;
    durationInMonths?: number;
    durationInHours?: number;
    skills?: string;
    averageFiveStarRating?: string;
    ratingCount?: number | null;
    totalEnrollmentCount?: string;
  };
};

type PropsFromWithMediaMinWidthMobilee = {
  matches: boolean;
};

type Props = ArticleRichEntityCardProps & PropsFromWithMediaMinWidthMobilee;

export const ArticleRichEntityCard = (props: Props) => {
  return !props.matches ? <MobileEntityCard {...props} /> : <DesktopEntityCard {...props} />;
};

export default withMediaMinWidthMobile<ArticleRichEntityCardProps>(ArticleRichEntityCard);
